import React from 'react'
import clsx from 'clsx'
import { ArrowDown2 } from 'iconsax-react'
import { useAppSelector } from '@SonarCX/hooks/redux'

import ButtonMenu from '@SonarCX/components/molecules/ButtonMenu2'

import { getUserType } from './helpers'
import { selectUserType } from '@SonarCX/slices/userType'
import useBaseStyles from '../styles'
import useStyles from './styles'

type UserEntryProps = {
  state: APICustomField
  handleChange: (prop: string) => (value: any) => void
}

const UserEntry: React.FC<UserEntryProps> = ({ state, handleChange }) => {
  const { types: userTypes } = useAppSelector(selectUserType)

  const baseClasses = useBaseStyles()
  const classes = useStyles()

  return (
    <div className={baseClasses.row}>
      <div className={baseClasses.label}>User Type</div>

      {/* @ts-ignore */}
      <ButtonMenu
        title='User Type'
        options={['null', ...userTypes.map(type => type.id)]}
        onSelect={opt => handleChange('config.id')(opt === 'null' ? null : opt)}
        renderOption={opt => getUserType(opt, userTypes)}
        className={clsx(baseClasses.menuRoot, classes.menu)}
        menuProps={{
          anchorOrigin: { horizontal: 'center', vertical: 'bottom' },
          transformOrigin: { horizontal: 'center', vertical: 'top' }
        }}
      >
        {getUserType(state.config?.id, userTypes)}
        <ArrowDown2 className={baseClasses.icon} />
      </ButtonMenu>
    </div>
  )
}

export default UserEntry
